(function () {
    angular.module('tradersyard').component('tyPrivacyLevel', {
        template:
            '<div class="privacy-status" ng-class="$ctrl.privacyDisplayArea" ng-switch on="$ctrl.privacyLevel">\n' +
            '                                    <span class="privacy-status-text" ng-switch-when="private">\n' +
            '                                        Private\n' +
            '                                    </span>\n' +
            '                                    <span class="privacy-status-text" ng-switch-when="protected">\n' +
            '                                        Protected\n' +
            '                                    </span>\n' +
            '                                    <span class="privacy-status-text" ng-switch-when="public">\n' +
            '                                        Public\n' +
            '                                    </span>\n' +
            '                                    <span class="privacy-status-text" ng-show="$ctrl.externalEvent">\n' +
            '                                        / External Event\n' +
            '                                    </span>\n' +
            '                                </div>',
        bindings: {
            privacyLevel: '<',
            privacyDisplayArea: '<',
            externalEvent: '<',
        },
        controller: PrivacyLevelController,
    });

    function PrivacyLevelController() {
        var ctrl = this;
    }
})();
